import {
  SETTINGS_DATA,
  SETTINGS_DATA_SUCCESS,
  SETTINGS_INPUT_CHANGEVALUE
} from "./actionTypes";

const initialState = {
  settings: {},
};

const CompareQuotation = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SETTINGS_DATA_SUCCESS:
      state = {
        ...state,
        settings: action.payload,
        loading: false,
      };
      break;
      
    case SETTINGS_INPUT_CHANGEVALUE:
      state = {
        ...state,
        settings: {
          ...state.settings,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }

  return state;
};
export default CompareQuotation;
